import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {
  DeleteStatus,
  exportAsExcelFile,
  formatDataExport,
  formatFilter,
  ItemMode,
  ListDocType,
  ListStatus,
  MasterDataStatus,
  REGEX, ServiceCardStatus, SharedService
} from '../../../shared/shared.service';
import { ItemComponent } from '../item/item.component';
import { ProxyDynamicService } from '../../../shared/service/proxy-dynamic.service';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { ColumnConfigExport } from '../../../shared/models/config-export.model';
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-butler',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
  providers: [DatePipe]
})
export class ListComponent implements OnInit {
  listDocType = ListDocType;
  listStatus = ListStatus;
  formConfig: any[] = [
    { name: 'code', title: 'butler.code', default: null, type: 'textAsLink', regex: REGEX.code, col: 12, required: true, sortBy: 'ASC', hint: true, hintLabel: 'input-hint.code' },
    { name: 'name', title: 'butler.name', default: null, type: 'text', max: 200, col: 12, required: true, sortBy: 'ASC' },
    { name: 'tax_code', title: 'owner.tax-code', default: null, type: 'text', max: 20, col: 12, sortBy: 'ASC' },
    { name: 'apartment', title: 'apartment.label', default: null, type: 'text', col: 12, viewOnly: true },
    { name: 'card_quantity', title: 'service-card.quantity', default: null, type: 'number', col: 12, viewOnly: true },
    { name: 'card_codes', title: 'card.code', default: null, type: 'text', col: 12, viewOnly: true },
    { name: 'phone', title: 'phone', default: null, type: 'text', col: 12, max: 12, min: 8, regex: REGEX.phone, sortBy: 'ASC', hint: false, hintLabel: 'input-hint.phone' },
    { name: 'email', title: 'email', default: null, type: 'text', max: 50, regex: REGEX.email, col: 12, width: '200px', sortBy: 'ASC', hint: true, hintLabel: 'input-hint.email' },
    { name: 'address', title: 'address', default: null, type: 'text', max: 250, col: 12, width: '250px', sortBy: 'ASC' },
    { name: 'birthday', title: 'birthday', default: null, type: 'date', col: 12, sortBy: 'ASC', maxDateToday: true },
    { name: 'doc_type', title: 'doc.type', default: null, type: 'dropdown', col: 12, options: this.listDocType, sortBy: 'ASC' },
    { name: 'doc_code', title: 'doc.code', default: null, type: 'text-number', max: 100, col: 12, sortBy: 'ASC' },
    { name: 'issue_place', title: 'doc.place', default: null, type: 'text', max: 250, col: 12, sortBy: 'ASC', width: '250px' },
    { name: 'issue_date', title: 'doc.date', default: null, type: 'date', col: 12, maxDateByControl: 'expired_date', maxDateToday: true, sortBy: 'ASC' },
    { name: 'expired_date', title: 'doc.expire', default: null, type: 'date', col: 12, minDateByControl: 'issue_date', sortBy: 'ASC' },
    { name: 'status', title: 'status.title', default: MasterDataStatus.Active, type: 'status', col: 12, options: this.listStatus, required: true, sortBy: 'ASC' },
    { name: 'creator', title: 'creator', default: null, type: 'text', col: 12, viewOnly: true },
    { name: 'date_created', title: 'created', default: moment().set({ h: 0, m: 0, s: 0, ms: 0 }).toDate(), type: 'date', col: 12, viewOnly: true, format: 'DD/MM/YYYY hh:mm:ss', showTime: true },
    { name: 'updater', title: 'updater', default: null, type: 'text', col: 12, viewOnly: true },
    { name: 'date_updated', title: 'updated', default: moment().set({ h: 0, m: 0, s: 0, ms: 0 }).toDate(), type: 'date', col: 12, viewOnly: true, format: 'DD/MM/YYYY hh:mm:ss', showTime: true },
  ];
  formFilterConfig = [
    { name: 'code', title: 'butler.code', default: '', type: 'text', col: 6 },
    { name: 'name', title: 'butler.name', default: '', type: 'text', col: 6 },
    { name: 'doc_code', title: 'doc.code', default: '', type: 'text', col: 6 },
    { name: 'status', title: 'status.title', default: MasterDataStatus.Active, type: 'status', col: 6, options: this.listStatus },
  ];
  filter: any = {
    limit: 15,
    page: 0,
    sort: 'code',
    code: null,
    name: null,
    status: MasterDataStatus.Active
  };
  source: any[] = [];
  totalRows: number = 0;
  listApartmentWithButler: any[] = [];
  listCardWithButler: any[] = [];

  constructor(
    private translate: TranslateService,
    private modalService: NzModalService,
    private noti: NzNotificationService,
    private service: ProxyDynamicService,
    private datePipe: DatePipe,
    private sharedService: SharedService,
  ) {
  }

  ngOnInit() {
    this.getData(this.filter);
  }

  getData(event?: any) {
    this.sharedService.showLoading(true);
    if (event) {
      Object.keys(event).forEach((key: any) => {
        this.filter[key] = event[key];
      })
    }

    const listChildQuery = [this.service.search('apartment', {
      fields: ['code', 'butler_id'],
      filter: {butler_id: {'_nnull': true}, deleted: {'_eq': DeleteStatus.NO}, status: {'_eq': MasterDataStatus.Active}}
    }), this.service.search('service_card', {
      fields: ['card_no', 'butler_id'],
      filter: {butler_id: {'_nnull': true}, deleted: {'_eq': DeleteStatus.NO}, status: {'_eq': MasterDataStatus.Active}}
    })];
    forkJoin(listChildQuery).subscribe(res => {
      if (res && res.length > 0) {
        this.listApartmentWithButler = res[0] || [];
        this.listCardWithButler = res[1] || [];
      }
    })

    this.service.searchWithMeta('butler', {
      fields: ['*', 'user_created.*', 'user_updated.*'],
      filter: formatFilter(this.filter, this.formFilterConfig),
      "limit": this.filter.limit,
      "page": this.filter.page,
      'sort': [this.filter['sort']]
    }).then(res => {
      this.totalRows = res.total;
      this.source = res?.data?.map(item => {
        item['creator'] = item['user_created'] ? [item['user_created']['first_name'], item['user_created']['last_name']].join(' ') : undefined;
        item['updater'] = item['user_updated'] ? [item['user_updated']['first_name'], item['user_updated']['last_name']].join(' ') : undefined;
        return item;
      });
      this.sharedService.showLoading(false);
    }).catch((error: any) => {
      this.service.handleError(error)
    });
  }

  onChangePage(event: any) {
    this.filter.page = event;
    this.getData();
  }

  onChangeSize(event: any) {
    this.filter.limit = event;
    this.getData();
  }

  edit(item: any) {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-butler',
      nzData: {
        mode: ItemMode.Edit,
        formConfig: this.formConfig,
        data: item,
        collection: 'butler'
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '',
          this.translate.instant('updateSuccess', { value: (this.translate.instant('butler.label')) }));
        this.getData();
      }
    });
  }

  view(item: any) {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-butler',
      nzData: {
        mode: ItemMode.View,
        formConfig: this.formConfig,
        data: item,
        collection: 'butler'
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '',
          this.translate.instant('updateSuccess', { value: (this.translate.instant('butler.label')) }));
        this.getData();
      }
    });
  }

  add() {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-butler',
      nzData: {
        mode: ItemMode.Add,
        formConfig: this.formConfig,
        collection: 'butler'
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '',
          this.translate.instant('addSuccess', { value: (this.translate.instant('butler.label')) }));
        this.getData();
      }
    });
  }

  delete(item: any) {
    this.service.count('service_card', {
      filter: { 'butler_id': item.id, 'deleted': DeleteStatus.NO, 'status': ServiceCardStatus.Block }
    }).then(res => {
      if (res > 0) {
        this.noti.create('error', '', this.translate.instant('service-card.error-delete', {count: res}));
        return;
      } else {
        this.service.delete('butler', item.id).then(() => {
          this.noti.create('success', '', this.translate.instant('deleteSuccess', { value: (this.translate.instant('butler.label')) }));
          this.getData();
        }).catch((error: any) => {
          this.service.handleError(error)
        });
      }
    });
  }

  export() {
    this.sharedService.showLoading(true);
    this.service.search('butler', {
      "limit": this.totalRows,
      "page": 0,
      'sort': [this.filter['sort']],
      fields: ['*', 'user_created.*', 'user_updated.*'],
      filter: formatFilter(this.filter, this.formFilterConfig),
    }).then(dataResult => {
      const configColumn: ColumnConfigExport[] = this.formConfig.map((item: any) => {
        switch (item.type) {
          case 'date':
            return { headerText: item.title, field: item.name, type: 'date' };
          case 'number':
            return { headerText: item.title, field: item.name, type: 'number' };
          case 'dropdown':
          case 'status':
            return { headerText: item.title, field: item.name, type: 'dropdown', options: item.options };
          default:
            return { headerText: item.title, field: item.name, type: 'text' };
        }
      })
      let dataExport: any[] = [];
      if (dataResult?.length > 0) {
        dataExport = dataResult.map(item => {
          item['creator'] = item['user_created'] ? [item['user_created']['first_name'], item['user_created']['last_name']].join(' ') : undefined;
          item['updater'] = item['user_updated'] ? [item['user_updated']['first_name'], item['user_updated']['last_name']].join(' ') : undefined;
          item['apartment'] = this.listApartmentWithButler.filter(r => r.butler_id === item['id']).map((ab) => ab.code).join(', ');
          item['card_quantity'] = this.listCardWithButler.filter(r => r.butler_id === item['id']).length;
          item['card_codes'] = this.listCardWithButler.filter(r => r.butler_id === item['id']).map((ab) => ab.card_no).join(', ');
          return item;
        })
      }
      const listExport = formatDataExport(dataExport, configColumn, this.translate);
      exportAsExcelFile(listExport, this.translate.instant('butler.title') + '_' + this.datePipe.transform(new Date(), 'yyMMdd'), this.noti, this.translate);
      this.sharedService.showLoading(false);
    }, (error: any) => {
      this.service.handleError(error)
    }).catch((error: any) => {
      this.service.handleError(error)
    });
  }

  onSort(event: any) {
    this.formConfig.forEach((col) => {
      if (col['name'] === event) {
        this.filter['sort'] = col['sortBy'] === 'ASC' ? event : '-' + event;
        col['sortBy'] = col['sortBy'] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        col['sortBy'] = 'ASC'
      }
    });
    this.getData();
  }
}
